import {Component, OnInit, Input, ViewChild} from '@angular/core';

import {MensajeService} from '../Mensaje.Service';
import {InformacionModel} from '../Modelo/Informacion.model';
import {InformacionEnum} from '../Enumeraciones/MensajeEnumeraciones.enum';

@Component(
  {
    selector: 'mensajeInformacion',
    templateUrl: './Informacion.template.html',
    styleUrls: ['./Informacion.scss'],
  })

export class InformacionComponent
{
  mensaje:InformacionModel = new InformacionModel();

  public abierto:boolean;
  public animacion:string;

  constructor(private informacionService: MensajeService)
  {
    this.abierto = false;
    this.animacion = "";
  }

  ngOnInit()
  {
    this.informacionService.IniciarMensajeInformacion().subscribe((mensaje: InformacionModel) =>
    {
      this.abierto = true;
      this.animacion = "fadeInUp";
      this.mensaje = mensaje;
      this.GetDatosMensaje(mensaje);
    });
  }

  GetDatosMensaje(datos : InformacionModel)
  {
    switch (datos.Tipo)
    {
      case InformacionEnum.normal:
        break;

      default:
        break;
    }
  }

  CerrarModal()
  {
    this.animacion = "fadeOutUp";

    setTimeout( () =>
    {
      this.abierto = false;
      this.mensaje = new InformacionModel();
    }, 310);

  }

}
